import React, { useEffect, useState } from 'react';
import '../index.scss';
import '../../../stylesheets/pages/conditions.scss';
import Helmet from 'react-helmet';
import _ from 'lodash';
import ConditionLeftMenu from '../ConditionLeftMenu';
import { getLdJson } from '../conditionLdJson';
import {
  CONDITIONS_CTA,
  CONDITIONS_DETAIL_CANONICAL,
  HOME_CANONICAL,
  MEDICALLY_REVIEWED_BY,
  WRITTEN_BY
} from '../../../constants/defaults';
import ReactMarkdown from 'react-markdown';
import SkipTo from '../../common/Tag/SkipTo';
import PopularDrugs from '../../common/PopularDrugs';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import AdSlot from '../../dfp/AdSlot';
import {
  CONDITIONS_TREATMENT_PAGE_HORIZONTAL_ADS,
  CONDITIONS_TREATMENT_PAGE_VERTICAL_LEFT_SIDE_ADS,
  CONDITIONS_TREATMENT_PAGE_VERTICAL_RIGHT_SIDE_ADS,
  GPT_HEAD_CONDITIONS_TREATMENT_PAGE
} from '../../../constants/gptHeadTags/conditionsPage';
import {
  AVERAGE_HORIZONTAL_AD_HEIGHT,
  AVERAGE_VERTICAL_AD_HEIGHT,
  BOTTOM_ANCHOR_AD_CONTAINER_ID,
  HORIZONTAL_ADS_CONTAINER_ID,
  MINIMUM_AD_SPACING,
  VERTICAL_ADS_CONTAINER_ID
} from '../../../constants/gptHeadTags/common';
import {
  injectHorizontalAds,
  insertVerticalAds
} from '../../dfp/DynamicAdsInjection';
import FactCheckModal from '../../common/FactCheckModal';
import AuthorProfile from '../../common/AuthorProfile';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import KeyTakeawaysSection from '../../common/KeyTakeawaysSection';
import PublishedDate from '../../common/PublishedDate';
import TableOfContents from '../../common/TableOfContnents';
import ConditionTabs from '../../common/ConditionTabs';
import Breadcrumb from '../../DrugDetails/Breadcrumb';
import AppPromoV1 from '../../common/AppPromoV1';
import RelatedArticles from '../../common/RelatedArticles/index.jsx';
import { fetchDrugClassRelatedBlogs } from '../../../services/Api/DrugInfo';
const { API } = require('../../../config/' + process.env.REACT_APP_ENV);

const ConditionDetailLayout = ({ condition, slugType }) => {
  const userName = _.getCookie('sessionId');
  const [visibleSection, setVisibleSection] = useState('');
  // eslint-disable-next-line no-unused-vars
  const [firstList, setFirstList] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [secondList, setSecondList] = useState([]);
  const [leftMenuVisibility, setLeftMenuVisibility] = useState(false);
  const [leftMenuClass, setLeftMenuClass] = useState('');
  const [conditionsContentData, setConditionsContent] = useState('');
  const [blogData, setBlogData] = useState([]);
  const [mainContent, setMainContent] = useState(condition?.content);
  // eslint-disable-next-line no-unused-vars
  const [conditionArticlePartOne, setConditionArticlePartOne] = useState(
    condition && condition.conditionArticlePartOne
  );
  // eslint-disable-next-line no-unused-vars
  const [conditionArticlePartTwo, setConditionArticlePartTwo] = useState(
    condition && condition.conditionArticlePartTwo
  );
  const isAdsVisible = API.ALLOW_CONDITIONS_TREATMENT_PAGE_ADS;
  const aid = condition?.slug?.split('-treatment-and-medications')?.[0];
  const sectionRefs = [];
  const handleScroll = () => {
    const scrollPosition = window.scrollY + 150;
    let finalList = [...firstList, ...secondList];
    const selected =
      !_.isEmpty(finalList) &&
      finalList.find(({ id }) => {
        const ele = id;
        if (ele) {
          const sectionDiv = document.getElementById(ele);
          const offsetTop = sectionDiv?.offsetTop;
          const offsetBottom = offsetTop + 200;
          return scrollPosition > offsetTop && scrollPosition < offsetBottom;
        }
      });
    if (selected && selected.value !== visibleSection) {
      setVisibleSection(selected.value);
    }
  };
  useEffect(() => {
    if (typeof document !== 'undefined') {
      let ctaDiv = document.getElementById('cta');
      if (ctaDiv) {
        if (document.getElementById('appPromo')) {
          document
            .getElementById('appPromo')
            .appendChild(document.getElementById('ctaSection'));
        }
      }
    }
  }, [mainContent]);

  const insert = (mainString, insString, pos) => {
    if (typeof pos == 'undefined') {
      pos = 0;
    }
    if (typeof insString == 'undefined') {
      insString = '';
    }
    return mainString.slice(0, pos) + insString + mainString.slice(pos);
  };

  const allowNodesFuncFirst = (node, index) => {
    return allowNodesFunc(node, index, firstList);
  };

  const allowNodesFuncSecond = (node, index) => {
    return allowNodesFunc(node, index, secondList);
  };

  const allowNodesFunc = (node, index, list) => {
    if (!leftMenuVisibility) {
      if (
        node.type == 'html' &&
        node.value.toString().match('<h2 id') &&
        node.value.match(/data-title="([A-Za-z0-9 _]*)"/)
      ) {
        const id = node.value.match(/id="(.*?)"/)[1];
        const value = node.value.match(/data-title="([A-Za-z0-9 _]*)"/)[1];
        if (!list.includes(value)) {
          list.unshift({ value, id });
          sectionRefs.push({
            section: value,
            ref: `item${index}`
          });
        }
      }
    }
    return true;
  };

  const handleBottomAdScroll = () => {
    const viewportHeight = window.innerHeight;
    const bottomTriggerElement = document.querySelector('.homepage-footer');
    const anchorDiv = document.getElementById('bottomStickyAd');
    // Check if the user has scrolled at least 1.5 times the height of the viewport
    if (window.scrollY >= 1.5 * viewportHeight) {
      // Check if the footer is visible
      if (bottomTriggerElement.getBoundingClientRect().top <= viewportHeight) {
        // Show the anchor div
        anchorDiv.classList.remove('bottomAdsBanner');
      } else {
        // Hide the anchor div
        anchorDiv.classList.add('bottomAdsBanner');
      }
    } else {
      // Hide the anchor div
      anchorDiv.classList.remove('bottomAdsBanner');
    }
  };

  useEffect(() => {
    setLeftMenuVisibility(false);
  }, [firstList, secondList]);

  useEffect(() => {
    if (window.location.hash) {
      const sectionId = window.location.hash.substr(1);
      if (sectionId) {
        const element = document.getElementById(sectionId);
        if (element) element.scrollIntoView();
      }
    }
    if (!_.isEmpty(userName)) {
      setLeftMenuClass('stickyLeftNav activeLeftNav');
      setConditionsContent('afterloginConditionsContent');
    } else {
      setLeftMenuClass('stickyLeftNav');
      setConditionsContent('');
    }
    handleScroll();
    if (condition?.content) {
      let value = condition?.content.split('<h2 ', 3).join('<h2 ').length;
      setMainContent(
        insert(condition?.content, "<div id='appPromo'></div>", value)
      );
    }
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    fetchDrugClassRelatedBlogs(encodeURI(condition?.conditionName), 12).then(
      res => {
        if (res) setBlogData(res?.posts);
      }
    );
    if (isAdsVisible) {
      const { sizeMapping } = window;
      const onSizeMappingLoad = () => {
        insertVerticalAds(
          CONDITIONS_TREATMENT_PAGE_VERTICAL_RIGHT_SIDE_ADS(
            sizeMapping.leftRight
          ),
          `[data-ads-containter="${VERTICAL_ADS_CONTAINER_ID.CONDITIONS_TREATMENT_PAGE_RIGHT_SIDE}"]`,
          '#app',
          AVERAGE_VERTICAL_AD_HEIGHT,
          isAdsVisible
        );
        insertVerticalAds(
          CONDITIONS_TREATMENT_PAGE_VERTICAL_LEFT_SIDE_ADS(
            sizeMapping.leftRight
          ),
          `[data-ads-containter="${VERTICAL_ADS_CONTAINER_ID.CONDITIONS_TREATMENT_PAGE_LEFT_SIDE}"]`,
          '#app',
          AVERAGE_VERTICAL_AD_HEIGHT,
          isAdsVisible
        );

        injectHorizontalAds(
          CONDITIONS_TREATMENT_PAGE_HORIZONTAL_ADS(sizeMapping.inContent),
          `[data-ads-containter="${HORIZONTAL_ADS_CONTAINER_ID.CONDITIONS_TREATMENT_PAGE_IN_CONTENT}"]`,
          '#app',
          AVERAGE_HORIZONTAL_AD_HEIGHT,
          isAdsVisible,
          MINIMUM_AD_SPACING
        );
      };
      if (typeof sizeMapping !== 'undefined') {
        if (sizeMapping.inContent) {
          onSizeMappingLoad();
        } else {
          const sizeMappingListener = () => {
            if (sizeMapping.inContent) {
              return onSizeMappingLoad();
            }
            return setTimeout(sizeMappingListener, 200);
          };
          sizeMappingListener();
        }
      }
      const anchorDiv = document.getElementById('bottomStickyAd');
      const viewportHeight = window.innerHeight;
      // Check if the total page is is at least 3X if the viewport height
      if (document.body.scrollHeight >= 3 * viewportHeight) {
        // Show the anchor div
        window.addEventListener(
          'scroll',
          _.throttle(handleBottomAdScroll, 250)
        );
      } else {
        anchorDiv.classList.remove('bottomAdsBanner');
      }
    }
    return () => {
      isAdsVisible &&
        window.removeEventListener('scroll', handleBottomAdScroll);
    };
  }, []);

  const displayAuthorProfile = (
    title = '',
    authorData = {},
    withDiscription = false
  ) => (
    <>
      {authorData?.name && (
        <AuthorProfile
          authorTitle={title}
          authorProfileLink={authorData?.reviewerPageOnSingleCare}
          authorDes={authorData?.title}
          authorName={authorData?.name}
          authorQualifications={authorData?.qualifications}
          authorImg={authorData?.photo}
          description={
            withDiscription
              ? documentToReactComponents(
                  JSON.parse(authorData?.biography || null)
                )
              : ''
          }
          className="userDataInfo"
        />
      )}
    </>
  );
  return (
    <div className="conditionsMainContainer">
      <Helmet>
        <title>{condition && condition.metaTitle}</title>
        <meta
          name="description"
          content={condition && condition.metaDescription}
        />
        <meta property="og:title" content={condition && condition.metaTitle} />
        <meta
          property="og:description"
          content={condition && condition.metaDescription}
        />
        <meta
          property="og:image"
          content={`${HOME_CANONICAL}/content/images/homepage/newSingleCareLogo.jpg`}
        />
        <meta
          property="og:url"
          content={`${CONDITIONS_DETAIL_CANONICAL}${
            condition && condition.slug
          }`}
        />
        <meta property="og:site_name" content="SingleCare" />
        <meta property="og:type" content="website" />
        {condition && !condition.metaRobots && (
          <meta
            name="ROBOTS"
            content="NOINDEX, FOLLOW, NOSNIPPET, NOODP, NOYDIR"
          />
        )}
        <meta property="aid_name" content={aid} />
        <meta property="placement_name" content="conditions-treatments" />
        <link
          rel="canonical"
          href={`${CONDITIONS_DETAIL_CANONICAL}${condition && condition.slug}`}
        />
        <script type="application/ld+json">{getLdJson(condition)}</script>
        {isAdsVisible && (
          <script async rel="preload">
            {GPT_HEAD_CONDITIONS_TREATMENT_PAGE}
          </script>
        )}
      </Helmet>

      <section className="conditionsMainpage">
        <section className="leftMenuWrapper">
          <div className={leftMenuClass} role="complementary">
            {leftMenuVisibility && (
              <ConditionLeftMenu
                sectionList={[...firstList, ...secondList]}
                visibleSection={visibleSection}
              />
            )}
          </div>
        </section>
        <section className="contentDescription">
          <div id="cta">
            <AppPromoV1 ctaLinks={CONDITIONS_CTA} classes="purpleBg" />
          </div>
          <div className="topBannerAds">
            <div className="adsInTopCenter">
              <AdSlot
                id="div-gpt-ad-1694716106511-0"
                featureDisplayAdsFlag={isAdsVisible}
              />
            </div>
          </div>
          {!_.isEmpty(condition?.linkedConditionPages) &&
            condition?.linkedConditionPages?.length > 0 && (
              <ConditionTabs
                breadcrumb={`${condition?.conditionName} Treatments`}
                h2Title={condition?.conditionName}
                slug={condition?.slug}
                slugType={slugType}
                linkedConditionPages={condition?.linkedConditionPages}
              />
            )}
          <section className="mainAllSection">
            <div
              className="leftAdsBannerContainer"
              data-ads-containter={
                VERTICAL_ADS_CONTAINER_ID.CONDITIONS_TREATMENT_PAGE_LEFT_SIDE
              }
            ></div>
            <section
              className={`conditionsContent ${conditionsContentData}`}
              data-ads-containter={
                HORIZONTAL_ADS_CONTAINER_ID.CONDITIONS_TREATMENT_PAGE_IN_CONTENT
              }
            >
              {_.isEmpty(condition?.linkedConditionPages) &&
                !_.isEmpty(condition && condition.conditionName) && (
                  <div
                    className="conditionsBreadcrumb"
                    role="navigation"
                    aria-label="Breadcrumb"
                  >
                    <Breadcrumb>
                      <span>
                        <a href="/">{`Home`}</a>
                      </span>
                      <a href={`/conditions-treatments`}>
                        <span> Treatments Directory</span>
                      </a>
                      <span>
                        {condition && condition.conditionName} Treatments
                      </span>
                    </Breadcrumb>
                  </div>
                )}
              <SkipTo>
                <h1>{condition && condition.title} </h1>
              </SkipTo>
              <div
                className={`${
                  !_.isEmpty(condition && condition.tableOfContents)
                    ? 'updateBottomMargin'
                    : ''
                }`}
              >
                {condition && (
                  <div className="authorLists topLists">
                    <>
                      {!_.isEmpty(condition?.medicalReviewer) &&
                        displayAuthorProfile(
                          MEDICALLY_REVIEWED_BY,
                          condition?.medicalReviewer?.[0],
                          false
                        )}
                      {!_.isEmpty(condition?.author) &&
                        displayAuthorProfile(
                          WRITTEN_BY,
                          condition?.author,
                          false
                        )}
                    </>
                  </div>
                )}

                <PublishedDate
                  publishedAt={condition?.publishedAt}
                  updatedAt={condition?.lastUpdatedDate}
                >
                  {(condition?.medicalReviewer?.[0] || condition?.author) && (
                    <FactCheckModal />
                  )}
                </PublishedDate>
              </div>
              {!_.isEmpty(condition && condition.tableOfContents) && (
                <TableOfContents content={condition.tableOfContents} />
              )}

              {!_.isEmpty(condition && condition.keyTakeaways) && (
                <KeyTakeawaysSection
                  keyTakeaways={JSON.parse(condition.keyTakeaways)}
                />
              )}

              <div className="conditionMainDataInfo">
                {_.isEmpty(condition && condition.conditionArticlePartOne) &&
                  _.isEmpty(condition && condition.conditionArticlePartTwo) &&
                  !_.isEmpty(condition && condition.content) && (
                    <ReactMarkdown
                      source={mainContent}
                      escapeHtml={false}
                      allowNode={allowNodesFuncFirst}
                    />
                  )}
              </div>

              {!_.isEmpty(condition?.newIntro) &&
              !_.isEmpty(condition?.newMainContent) ? (
                <div>
                  {documentToReactComponents(
                    JSON.parse(condition?.newIntro || null)
                  )}
                  <AppPromoV1 ctaLinks={CONDITIONS_CTA} classes="purpleBg" />
                  {!_.isEmpty(condition && condition.tableHeader) && (
                    <>
                      <h2 className="tableHead">
                        {condition && condition.tableHeader}{' '}
                      </h2>
                      <table
                        cellPadding="0"
                        cellSpacing="0"
                        className="conditionTable"
                      >
                        <tr>
                          <th>Drug name</th>
                          <th>Learn more</th>
                          <th>See SingleCare price</th>
                        </tr>
                        {condition &&
                          condition.listOfDrugs.map((drug, index) => {
                            return (
                              <tr className="dataTable" key={index}>
                                <td>{drug.name}</td>
                                <td>
                                  <a
                                    href={`/prescription/${drug.seoName}/what-is`}
                                  >
                                    {' '}
                                    {`${drug.seoName}`}
                                    &nbsp;<span>details</span>
                                  </a>
                                </td>
                                <td>
                                  <div className="separatorLine mobile-only">
                                    <LazyLoadImage
                                      src="../content/images/icons/lineBottom.png"
                                      height="9"
                                      width="256"
                                    />
                                  </div>
                                  <a
                                    href={`/prescription/${drug.seoName}`}
                                    className="sc-btn-pink rx-get-this-price themeFocus"
                                  >
                                    Get free coupon
                                  </a>
                                </td>
                              </tr>
                            );
                          })}
                      </table>
                    </>
                  )}
                  <div className="conditionMainDataInfo">
                    {documentToReactComponents(
                      JSON.parse(condition?.newMainContent || null)
                    )}
                  </div>
                </div>
              ) : (
                !_.isEmpty(condition && condition.conditionArticlePartOne) &&
                !_.isEmpty(condition && condition.conditionArticlePartTwo) &&
                !_.isEmpty(condition && condition.tableHeader) && (
                  <div>
                    {!_.isEmpty(
                      condition && condition.conditionArticlePartOne
                    ) && (
                      <div className="conditionMainDataInfo">
                        <ReactMarkdown
                          source={conditionArticlePartOne}
                          escapeHtml={false}
                          allowNode={allowNodesFuncFirst}
                        />
                      </div>
                    )}

                    <AppPromoV1 ctaLinks={CONDITIONS_CTA} classes="purpleBg" />
                    {!_.isEmpty(condition && condition.tableHeader) && (
                      <>
                        <h2 className="tableHead">
                          {condition && condition.tableHeader}{' '}
                        </h2>
                        <table
                          cellPadding="0"
                          cellSpacing="0"
                          className="conditionTable"
                        >
                          <tr>
                            <th>Drug name</th>
                            <th>Learn more</th>
                            <th>See SingleCare price</th>
                          </tr>
                          {condition &&
                            condition.listOfDrugs.map((drug, index) => {
                              return (
                                <tr className="dataTable" key={index}>
                                  <td>{drug.name}</td>
                                  <td>
                                    <a
                                      href={`/prescription/${drug.seoName}/what-is`}
                                    >
                                      {' '}
                                      {`${drug.seoName}`}
                                      &nbsp;<span>details</span>
                                    </a>
                                  </td>
                                  <td>
                                    <div className="separatorLine mobile-only">
                                      <LazyLoadImage
                                        src="../content/images/icons/lineBottom.png"
                                        height="9"
                                        width="256"
                                      />
                                    </div>
                                    <a
                                      href={`/prescription/${drug.seoName}`}
                                      className="sc-btn-pink rx-get-this-price themeFocus"
                                    >
                                      Get free coupon
                                    </a>
                                  </td>
                                </tr>
                              );
                            })}
                        </table>
                      </>
                    )}

                    {!_.isEmpty(
                      condition && condition.conditionArticlePartTwo
                    ) && (
                      <div className="conditionMainDataInfo">
                        <ReactMarkdown
                          source={conditionArticlePartTwo}
                          escapeHtml={false}
                          allowNode={allowNodesFuncSecond}
                        />
                      </div>
                    )}
                  </div>
                )
              )}

              <section className="bottomUserDataInfo bottomInfo">
                {condition && (
                  <div className="authorLists">
                    <>
                      {!_.isEmpty(condition?.medicalReviewer) &&
                        displayAuthorProfile(
                          MEDICALLY_REVIEWED_BY,
                          condition?.medicalReviewer?.[0],
                          true
                        )}
                      {!_.isEmpty(condition?.author) &&
                        displayAuthorProfile(
                          WRITTEN_BY,
                          condition?.author,
                          true
                        )}
                    </>
                  </div>
                )}
              </section>

              {!_.isEmpty(condition && condition.relatedDrugs) && (
                <section className="relatedDrugs mobile-section homepage-new">
                  <section className="top-drugs">
                    <article>
                      <h4>{`Related Drugs`}</h4>
                      <ul>
                        {condition &&
                          condition.relatedDrugs.map((item, id) => {
                            return (
                              <>
                                {item.drugName && (
                                  <li key={id}>
                                    <a href={`/prescription/${item.seoName}`}>
                                      {item.drugName}
                                    </a>
                                  </li>
                                )}
                              </>
                            );
                          })}
                      </ul>
                    </article>
                  </section>
                </section>
              )}
              {!_.isEmpty(condition && condition.relatedConditions) && (
                <section className="relatedDrugs mobile-section homepage-new">
                  <section className="top-drugs">
                    <article>
                      <h4>{`Related Conditions`}</h4>
                      <ul>
                        {condition &&
                          condition.relatedConditions.map((item, id) => {
                            return (
                              <>
                                {item.conditionName && (
                                  <li key={id}>
                                    <a href={`/conditions/${item.slug}`}>
                                      {item.h1}
                                    </a>
                                  </li>
                                )}
                              </>
                            );
                          })}
                      </ul>
                    </article>
                  </section>
                </section>
              )}
              {!_.isEmpty(blogData) && (
                <section className="homepage-new">
                  <section id="news-research">
                    <RelatedArticles
                      blogData={blogData}
                      drugName={condition?.conditionName}
                      isRelatedArticle={false}
                    />
                  </section>
                </section>
              )}
              {!_.isEmpty(condition && condition.popularDrugs) && (
                <PopularDrugs
                  popularDrugs={condition.popularDrugs.drugs}
                  text="discounts"
                />
              )}
            </section>
            <div
              className="rightAdsBannerContainer"
              data-ads-containter={
                VERTICAL_ADS_CONTAINER_ID.CONDITIONS_TREATMENT_PAGE_RIGHT_SIDE
              }
            ></div>
          </section>
          <div className="adsInCenter marginBottom-20">
            <AdSlot
              id="div-gpt-ad-1694716566013-0"
              featureDisplayAdsFlag={isAdsVisible}
            />
          </div>
        </section>
      </section>
      <div
        id="bottomStickyAd"
        className="bottomLastAds"
        data-ads-container={
          BOTTOM_ANCHOR_AD_CONTAINER_ID.CONDITIONS_TREATMENT_PAGE
        }
      >
        <AdSlot
          id="div-gpt-ad-1694716740577-0"
          enableCloseBtn={true}
          innerDivClassName="p-1"
          featureDisplayAdsFlag={isAdsVisible}
        />
      </div>
    </div>
  );
};

export default ConditionDetailLayout;
